import { render } from "./LocationStatuses.vue?vue&type=template&id=47c6d3c3&scoped=true"
import script from "./LocationStatuses.vue?vue&type=script&lang=js"
export * from "./LocationStatuses.vue?vue&type=script&lang=js"

import "./LocationStatuses.vue?vue&type=style&index=0&id=47c6d3c3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47c6d3c3"]])

export default __exports__